import { DataBean } from "../DataBean";

export class CloseYearPeriodAdjustments extends DataBean {

    public async closeYearPeriodForAdjustments(year: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_closeYearPeriodForAdjustments_Number_Number", [year, idEmployee]);
    }

}